<template>
  <svg
    width="48"
    height="49"
    viewBox="0 0 48 49"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 16.5962C18.3431 16.5962 17 17.9393 17 19.5962V33.5962C17 35.253 18.3431 36.5962 20 36.5962H32.6667L36.4 39.3962C37.0592 39.8906 38 39.4202 38 38.5962V36.5962H41C42.6569 36.5962 44 35.253 44 33.5962V19.5962C44 17.9393 42.6569 16.5962 41 16.5962H20Z"
      fill="white"
    />
    <path
      d="M32.6667 36.5962L33.1467 35.9562L32.9333 35.7962H32.6667V36.5962ZM36.4 39.3962L35.92 40.0362V40.0362L36.4 39.3962ZM38 36.5962V35.7962H37.2V36.5962H38ZM17.8 19.5962C17.8 18.3812 18.785 17.3962 20 17.3962V15.7962C17.9013 15.7962 16.2 17.4975 16.2 19.5962H17.8ZM17.8 33.5962V19.5962H16.2V33.5962H17.8ZM20 35.7962C18.785 35.7962 17.8 34.8112 17.8 33.5962H16.2C16.2 35.6949 17.9013 37.3962 20 37.3962V35.7962ZM32.6667 35.7962H20V37.3962H32.6667V35.7962ZM32.1867 37.2362L35.92 40.0362L36.88 38.7562L33.1467 35.9562L32.1867 37.2362ZM35.92 40.0362C37.1066 40.9262 38.8 40.0795 38.8 38.5962H37.2C37.2 38.761 37.0118 38.8551 36.88 38.7562L35.92 40.0362ZM38.8 38.5962V36.5962H37.2V38.5962H38.8ZM41 35.7962H38V37.3962H41V35.7962ZM43.2 33.5962C43.2 34.8112 42.215 35.7962 41 35.7962V37.3962C43.0987 37.3962 44.8 35.6949 44.8 33.5962H43.2ZM43.2 19.5962V33.5962H44.8V19.5962H43.2ZM41 17.3962C42.215 17.3962 43.2 18.3812 43.2 19.5962H44.8C44.8 17.4975 43.0987 15.7962 41 15.7962V17.3962ZM20 17.3962H41V15.7962H20V17.3962Z"
      fill="#4D4E58"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7 10.5962C5.34315 10.5962 4 11.9393 4 13.5962V27.5962C4 29.253 5.34315 30.5962 7 30.5962H9V32.5962C9 33.4202 9.94076 33.8906 10.6 33.3962L14.3333 30.5962H28C29.6569 30.5962 31 29.253 31 27.5962V13.5962C31 11.9393 29.6569 10.5962 28 10.5962H7Z"
      fill="white"
    />
    <path
      d="M9 30.5962H9.8V29.7962H9V30.5962ZM10.6 33.3962L11.08 34.0362L10.6 33.3962ZM14.3333 30.5962V29.7962H14.0667L13.8533 29.9562L14.3333 30.5962ZM4.8 13.5962C4.8 12.3812 5.78497 11.3962 7 11.3962V9.79619C4.90132 9.79619 3.2 11.4975 3.2 13.5962H4.8ZM4.8 27.5962V13.5962H3.2V27.5962H4.8ZM7 29.7962C5.78497 29.7962 4.8 28.8112 4.8 27.5962H3.2C3.2 29.6949 4.90132 31.3962 7 31.3962V29.7962ZM9 29.7962H7V31.3962H9V29.7962ZM9.8 32.5962V30.5962H8.2V32.5962H9.8ZM10.12 32.7562C9.98815 32.8551 9.8 32.761 9.8 32.5962H8.2C8.2 34.0795 9.89338 34.9262 11.08 34.0362L10.12 32.7562ZM13.8533 29.9562L10.12 32.7562L11.08 34.0362L14.8133 31.2362L13.8533 29.9562ZM28 29.7962H14.3333V31.3962H28V29.7962ZM30.2 27.5962C30.2 28.8112 29.215 29.7962 28 29.7962V31.3962C30.0987 31.3962 31.8 29.6949 31.8 27.5962H30.2ZM30.2 13.5962V27.5962H31.8V13.5962H30.2ZM28 11.3962C29.215 11.3962 30.2 12.3812 30.2 13.5962H31.8C31.8 11.4975 30.0987 9.79619 28 9.79619V11.3962ZM7 11.3962H28V9.79619H7V11.3962Z"
      fill="#4D4E58"
    />
    <path
      d="M23.7923 13.0962H26.5C27.6046 13.0962 28.5 13.9916 28.5 15.0962V26.0962C28.5 27.2008 27.6046 28.0962 26.5 28.0962H10.5L23.7923 13.0962Z"
      fill="#E0E5FF"
    />
    <rect
      x="9.5"
      y="18.0962"
      width="4"
      height="4"
      rx="2"
      fill="#7B90FF"
    />
    <rect
      x="15.5"
      y="18.0962"
      width="4"
      height="4"
      rx="2"
      fill="#7B90FF"
    />
    <rect
      x="21.0498"
      y="18.0962"
      width="4"
      height="4"
      rx="2"
      fill="#7B90FF"
    />
  </svg>
</template>
